import apiClient from './apiClient';

export const usersAPI = {
  list: (params) => apiClient.get('/auth/users/', { params }),
  get: (id) => apiClient.get(`/auth/users/${id}/`),
};
